module.exports = __webpack_public_path__ + "static/CSF4-941310cfe93646f37daec97d45c56786.png";